// A lightweight value object for a New Zealand region, built from the `regions` reference
// table passed in the online app config. Used to resolve a `region_id` URL param (a Rails
// friendly_id — either the cached slug or the integer id) to a region code, which is what
// the experience markers are matched against.

export default class Region {

    constructor(props={}) {
        this.id = props.id;
        this.code = props.code;
        this.slug = props.slug;
    }

    // True when `param` (a friendly_id from the URL) identifies this region — either its
    // cached slug (e.g. "marlborough") or its integer id rendered as a string (e.g. "42").
    matchesFriendlyId(param) {
        if (param == null) { return false }
        return this.slug == param || String(this.id) == String(param);
    }

    // True when `code` is this region's code (e.g. "MARLBOROUGH").
    matchesCode(code) {
        if (code == null) { return false }
        return this.code == code;
    }

}
